import React from 'react';
const SearchItem = ({ name, type, url }) => {
    return (<>
      <a href={url} className="overview-item">
        <div className="overview-item__block">
          <div className="overview-item__content">
            <div className="overview-item__title">
              {name}
            </div>
            <div className="overview-item__description">
              {type}
            </div>
          </div>
        </div>
      </a>
    </>);
};
export default SearchItem;
